import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import TaxView from '../components/version-4/viewForms/TaxView'
import { useTax } from '../hooks/CompanyConfiguration/useTax'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewTax() {
  const { tax, getTax } = useTax()
  const params = useParams()
  React.useEffect(() => {
    getTax({ taxId: params.taxId })
  }, [params.taxId])


  return (
    <Layout heading="Tax" heading2="Info" url1={ROUTES.TAX} none>
      {tax ? (
        <HeaderTabLayout
          heading="Tax"
          content={<TaxView tax={tax} />}
          view
          url={`/edit-tax/${params.taxId}`}
        />
      ):<Loader/>}
    </Layout>
  )
}

export default ViewTax
